
<template>

	<div>
		<van-nav-bar title="分享链接回复" left-text="返回" left-arrow fixed placeholder @click-left="goBack" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<van-button type="info" size="large" @click="add" style="position: fixed;bottom: 0;z-index: 1;" v-if="datas.length">添加</van-button>

		<van-empty description="什么都没有" image="search" v-if="!datas.length && show_empty">
			<van-button round type="info" class="bottom-button" @click="add">
				添加
			</van-button>
		</van-empty>
		<van-panel style="margin: 10px;border-radius: 10px;box-shadow: 0 0.02rem 0.06rem 0 rgba(24, 107, 198, 0.3);"
		 v-for="(item, index) in datas" :key="index" :title="'关键词【' + item.keyword + '】'" :status="item.switch_checked?'状态：正常':'状态：关闭'">
			<div style="padding: 20px;">
				<a style="color: #1989fa;" :href="item.li_url">{{item.li_title}}</a>
			</div>
			<template #footer>
				<van-button size="small" type="info" @click="edit(index)">修改</van-button>
				&nbsp;
				<van-button size="small" type="danger" @click="del(index)">删除</van-button>
			</template>
		</van-panel>


		<van-popup v-model="show_model" closeable round :style="{ height: '58%', width: '95%' }">
			<div style="padding: 30px 10px 0 10px;">
				<van-form @submit="onSubmit">
					<van-field v-model="keyword" name="keyword" label="关键词:" placeholder="在这里输入关键词" :rules="[{ required: true, message: '请填写关键词' }]" show-word-limit maxlength="10" />
					 <van-field v-model="li_title" name="li_title" label="链接名字:" placeholder="链接名字" :rules="[{ required: true, message: '请填写链接名字' }]" show-word-limit maxlength="30" />
					  <van-field v-model="li_url" name="li_url" label="跳转网址:" placeholder="请填写跳转网址 http(s):// " :rules="[{ required: true, message: '请填写跳转网址 http(s):// 开头' }]" show-word-limit />
					   
					<van-field name="switch_checked" label="启用">
						<template #input>
							<van-switch v-model="switch_checked" size="20" />
						</template>
					</van-field>
					
					<van-field name="is_match" label="精确匹配">
						<template #input>
							<van-switch v-model="is_match" size="20" />
						</template>
					</van-field>

					<div style="margin: 16px;">
						<van-button round block type="info" native-type="submit">
							提交
						</van-button>
					</div>
				</van-form>
			</div>
		</van-popup>
		<div style="height: 100px;"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				op: 'link',
				switch_checked: true,
				is_match: false,

				show_model: false,
				li_title: '',
				li_url: '',
				keyword: '',


				datas: [],

				edit_id: 0,

				show_empty: false
			}
		},
		created() {
			var group_id = localStorage.getItem('select_id')
			if (!group_id) {
				this.$router.push('/member-center')
				return;
			}
			this.group_id = group_id

			this.get()
		},
		methods: {
			add() {
				this.show_model = true
			},
			edit(e) {
				var id = this.datas[e].id
				var type = this.datas[e].type

				this.$ApiUtil.GroupCenterSrc.find({
					id: id
				}).then(res => {
					this.li_url = res.data.li_url
					this.li_title = res.data.li_title
					this.keyword = res.data.keyword
					this.show_model = true

					this.switch_checked = res.data.switch_checked
					this.is_match = res.data.is_match

					this.edit_id = id

				})
			},
			del(e) {
				this.$dialog.confirm({
					message: '确认删除吗?'
				}).then(() => {
					var id = this.datas[e].id
					this.$ApiUtil.GroupCenterSrc.del({
						id: id
					}).then(res => {
						this.$toast.success(res.message)
						this.get()
					})
				})

			},
			get() {
				this.$ApiUtil.GroupCenterSrc.get({
					a: this.group_id,
					v: this.op
				}).then(res => {
					this.datas = res.data
					this.show_empty = true
				})
			},
			submit(values, type) {
				values.type = this.op
				this.$ApiUtil.GroupCenterSrc.post({
					op: this.op,
					id: this.group_id,
					values: JSON.stringify(values),
					edit_id: this.edit_id
				}).then(res => {
					if (!res.status) {
						this.$toast.fail(res.message)
					}
					this.get()
					this.$nextTick(() => {
						this.keyword = ''
						this.card_alias = ''
						this.card_nick = ''
						this.show_model = false
					})

					//, this.reload()
					// location.reload()
				})
			},
			onSubmit(e) {
				this.submit(e)
			},
			goBack() {
				this.$router.back()
			}
		}
	}
</script>
<style>
	.bottom-button {
		width: 160px;
		height: 40px;
	}
</style>
